import { useState, useEffect } from 'react';
import { BasePicker } from '../shared/BasePicker';
import { pickersDataService } from '../../services/pickersDataService';
import type { SuccessStory } from '../../types/success-stories';

interface SuccessStoryPickerProps {
    value: string;
    onChange: (story: SuccessStory | null) => void;
    label?: string;
    required?: boolean;
    className?: string;
    usageMap?: Record<string, string[]>;
}

export const SuccessStoryPicker = ({
    value,
    onChange,
    label = "Success Story",
    required = false,
    className = "",
    usageMap
}: SuccessStoryPickerProps) => {
    const [stories, setStories] = useState<SuccessStory[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadStories = async () => {
            try {
                setLoading(true);
                const fetchedStories = await pickersDataService.getAllSuccessStories();
                setStories(fetchedStories);
            } catch (error) {
                console.error('Failed to load success stories:', error);
            } finally {
                setLoading(false);
            }
        };

        loadStories();
    }, []);

    return (
        <BasePicker<SuccessStory>
            value={value}
            onChange={onChange}
            items={stories}
            config={{
                modalTitle: 'Select Success Story',
                searchPlaceholder: 'Search stories...',
                emptyStateMessage: loading ? 'Loading stories...' : 'No stories available',
                noSelectionMessage: 'No story selected',
                getItemId: (story) => story.id,
                getItemDisplayName: (story) => story.title,
                usageMap
            }}
            label={label}
            required={required}
            className={className}
        />
    );
};
